<template>
    <q-table
            :columns="columns"
            :rows="clients"
            selection="multiple"
            :selected="selected"
            :selected-rows-label="selectedLabel"
            :loading="isLoading"
            :rows-per-page-options="[0]"
            flat
            @update:selected="$emit('update:selected', $event)">
        <template v-slot:no-data>
            <message v-show="!isLoading" class="full-width">
                User is assigned to every client.
            </message>
        </template>
    </q-table>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Client } from '@/type';
import { HasTaskMixin } from '@/mixins';
import { name as clientNameFilter } from '@/client/client-filter';
import Message from '@/components/message/Message.vue';
import repository from './userClientRepository';

interface Data {
  task: Promise<Client[]>|null,
  columns: object[],
  clients: Client[],
}

export default defineComponent({
  emits: ['update:selected'],
  mixins: [HasTaskMixin],
  props: {
    userId: {
      type: Number,
      required: true,
    },
    selected: {
      type: Array as () => Client[],
      default() {
        return [];
      },
    },
    keyword: String,
  },
  data(): Data {
    return {
      task: null,
      columns: [
        {
          name: 'name',
          label: 'Name',
          field: clientNameFilter,
          align: 'left',
        },
        {
          name: 'fileRefNo',
          label: 'File Ref No.',
          field: 'fileRefNo',
          align: 'left',
        },
      ],
      clients: [],
    };
  },
  watch: {
    userId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
    keyword: 'load',
  },
  methods: {
    selectedLabel(): string {
      const count = this.selected.length;
      const total = this.clients.length;
      return `${count} client${(count === 1) ? '' : 's'} selected of ${total}`;
    },
    load() {
      this.task = repository.findUnassigned(this.userId, this.keyword);
      this.task.then((clients: Client[]) => {
        this.clients = clients;
      });
    },
    removeItem(client: Client) {
      const index = this.clients.findIndex(c => c.id === client.id);
      if (index >= 0) {
        this.clients.splice(index, 1);
      }
    },
  },
  components: {
    Message,
  },
});
</script>
